import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import BaseRoutes from "routes/Routes";

import { useThemeHook } from "hooks/profile/useThemeHook";
import { WeekProvider } from "modules/clubs/supperAdminClubManagement/superAdminClub/ClubWeekProvider";

function App() {
  const { setInitialTheme } = useThemeHook();
  useEffect(setInitialTheme, []);
  return (
    <div className="App">
      <WeekProvider>
        <BaseRoutes />
        <ToastContainer />
      </WeekProvider>
    </div>
  );
}

export default App;
